var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barcode-field-box"},[_c('button',{staticClass:"button style-3",on:{"click":function($event){$event.preventDefault();return _vm.startScanner.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('forms.scan')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }